/**
 * management.module.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { ModuleWithProviders, NgModule, Provider } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "../shared/shared.module";

// OWN SERVICES

// import { AggregationService } from "./aggregation.service";

// OWN COMPONENTS

// import { AggregationTaskComponent }
//     from "./aggregation-task.component";
import { ManagementPanelComponent } from "./management-panel.component";
import { ResetPasswordModalComponent } from "../auth/reset-password-modal.component";
import { ModalService } from "app/common/modal.service";
import { RemoveUserGroupModalComponent } from "./remove-user-group-modal.component";

// MISC

const MANAGEMENT_ROUTING: ModuleWithProviders =
    RouterModule.forChild([{ path: "", component: ManagementPanelComponent }]);

@NgModule({
    imports: [SharedModule, MANAGEMENT_ROUTING],
    declarations: [
        ManagementPanelComponent,
        ResetPasswordModalComponent,
        RemoveUserGroupModalComponent
    ],
    entryComponents: [ResetPasswordModalComponent, RemoveUserGroupModalComponent],
    exports: [],
    providers: [ModalService]
})
export class ManagementModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ManagementModule,
            // providers: [AggregationService]
        };
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/management/management.module.ts